<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">{{ event_regex.id }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-select
                v-model="event_regex.customers"
                :items="possibleCustomers"
                attach
                outline
                chips
                clearable
                label="Customer"
                color="purple"
              ></v-select>
              
              <v-select
                v-model="event_regex.project"
                :items="possibleProjects"
                attach
                outline
                chips
                clearable
                label="Project/Study the mapping belongs to"
                color="purple"
              ></v-select>

              <v-select
                v-model="event_regex.event_type"
                :items="possibleEventTypes"
                attach
                outline
                chips
                clearable
                label="Maps to Event Type"
                color="purple"
              ></v-select>

              <v-alert
                :value="true"
                type="info"
              >
                This regex will be used in a Presto Query on Athena to match against the <code>text</code> field.
                So there are specific commands allowed for Presto. <code>regexp_like(lower(text), 'YOUR REGEX
                HERE')</code> should be included in these statements.
              </v-alert>

              <v-textarea
                name="Regex"
                v-model="event_regex.regex"
                label="Event Type Regex"
                :rules="[v => !!v || 'Please specify a regular expression']"
                required
                auto-grow
                hint="A valid regular expression used for recognizing special events."
                outline
              ></v-textarea>
              <v-textarea
                name="Notes"
                v-model="event_regex.notes"
                label="Event Type Notes"
                auto-grow
                hint="Whatever you want to say about the eventtype."
                outline
              ></v-textarea>
              <v-btn @click="submit"
                     color="error"
                     large>Update Event Type Regex
              </v-btn>
              <v-btn @click="validate"
                     color="green darken-1"
                     class="white--text"
                     large>
                Validate with Athena
                <v-icon right dark>verified_user</v-icon>
              </v-btn>
              <v-btn @click="cancel">Cancel</v-btn>

              <v-checkbox
                v-model="event_regex.trigger_file_generation"
                label="Trigger regex file generation after saving this regex."
              ></v-checkbox>

              <v-switch
                v-model="event_regex.is_inactive"
                label="Set Inactive"
                color="error"
                hide-details
              ></v-switch>

            </v-card-text>

            <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :timeout="9000"
              :top="true"
              multi-line
              :vertical="true"
            >
              {{ text }}
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>

          </v-card>
        </v-form>
      </v-container>
    </v-layout>
    <v-dialog v-model="validate_dialog"
              scrollable>
      <v-card>
        <v-card-title>Matched fragments</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-list>
            <v-list-tile v-for="item in validatedFragments"
                         :key="item">

              <v-list-tile-content>
                <v-list-tile-title :title="item"
                                   v-text="item"></v-list-tile-title>
              </v-list-tile-content>

            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red darken-1" flat @click="validate_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    name: "EventRegexCreate",
    data() {
      return {
        validatedFragments: [],
        validate_dialog: false,
        valid: true,
        errored: false,
        event_regex: {
          trigger_file_generation: false,
          project: '',
          customer: '',
          regex: '',
          notes: '',
          event_type: null,
          is_inactive: false
        },
        snackbar: false,
        text: '',
        loading: true,
        possibleEventTypes: Config.EVENT_TYPES,
        possibleProjects: Config.STUDIES_PROJECTS.sort(),
        possibleCustomers: Config.CUSTOMERS.sort()       
      }
    },
    mounted() {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      this.$emit('TriggerLoading', true);
      axios.get(`${Config.API_URL}/event_regex/${this.$route.params.id}`).then(response => {
        this.event_regex = response.data;
        this.$emit('TriggerLoading', false);
      }).catch(error => {
        this.$emit('TriggerLoading', false);
        console.error(error);
      });
    },
    methods: {
      'cancel': function () {
        this.$router.go(-1)
      },
      'submit': function () {

        if (this.$refs.form.validate()) {

          this.$emit('TriggerLoading', true)

          axios.put(`${Config.API_URL}/event_regex/${this.$route.params.id}`, this.$data.event_regex)
            .then(response => {
              console.info(response.data)
              this.text = response.data.message
              this.snackbar = true
              this.$emit('TriggerLoading', false)
              // this.$router.push({ name: 'event_regex' })
            })
            .catch(error => {
              this.text = `${error.response.data.message} (${error})`
              this.errored = true
              this.snackbar = true
              this.$emit('TriggerLoading', false)
            })
        }
      },
      'validate': function () {
        this.$emit('TriggerLoading', true)
        axios
          .post(`${Config.API_URL}/event_regex/validate`, this.$data.event_regex.regex +'_separator___value_'+ this.$data.event_regex.event_type)
          .then(response => {
            this.validatedFragments = response.data.fragments
            this.validate_dialog = true
            this.$emit('TriggerLoading', false)
          })
          .catch(error => {
            this.text = `${error.response.data.message} (${error})`
            this.snackbar = true
            this.$emit('TriggerLoading', false)
          })
      }
    },
  }
</script>
